import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, HiddenSpan } from 'components'
import * as Types from 'types'
import { getFormWideErrorMessage } from 'utils'
import { selectors as globalPartnerSelectors } from 'partner-portal-reducer'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { waitFor } from 'lp-hoc'

import { ArtistPartnershipForm } from '../forms'

const propTypes = {
  onClose: PropTypes.func.isRequired,
  artistOptions: PropTypes.arrayOf(Types.searchSuggestion),
  onSubmit: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  partner: Types.partner.isRequired,
  visibleSchoolYearId: PropTypes.string.isRequired,
}

const defaultProps = {
  artistOptions: [],
  partner: {},
}

function AddArtistPartnershipModal({
  onClose,
  artistOptions,
  onSubmit,
  onSubmitSuccess,
  partner,
  visibleSchoolYearId,
}) {
  const [formWideError, setFormWideError] = useState(null)
  const [submitFailCount, setSubmitFailCount] = useState(0)

  const { programs, partnerships } = partner
  const schools = partnerships.filter((p) => !!p.schoolId)

  return (
    <Modal onClose={onClose}>
      <h2>Add New Partnership</h2>
      <div className="modal-content">
        <div role="alert" aria-atomic>
          {formWideError && (
            <p className="full-error-message">
              {/* The hidden count will force screen readers to announce
               the error again even when it's exactly the same */}
              {formWideError} <HiddenSpan>{submitFailCount}</HiddenSpan>
            </p>
          )}
        </div>
        <ArtistPartnershipForm
          artistOptions={artistOptions}
          schoolPartnerships={schools}
          programPartnerships={programs}
          visibleSchoolYearId={visibleSchoolYearId}
          onSubmit={onSubmit}
          onSubmitSuccess={onSubmitSuccess}
          onSubmitFail={(errors, _, submitError) => {
            setSubmitFailCount((sfc) => sfc + 1)
            const msg = getFormWideErrorMessage(errors, submitError)
            setFormWideError(msg)
          }}
        />
      </div>
    </Modal>
  )
}

AddArtistPartnershipModal.propTypes = propTypes
AddArtistPartnershipModal.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    partner: globalPartnerSelectors.partner(state),
  }
}

const mapDispatchToProps = {}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  waitFor(['partner'])
)(AddArtistPartnershipModal)
